import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {LoginGuard} from 'shared/guards/login.guard';
import {EventRegistrationComponent} from './event-registration.component';

const routes: Routes = [
  {path: 'event-registration/codes', component: EventRegistrationComponent, canActivate: [LoginGuard]},
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
  ],
})

export class EventRegistrationRoutingModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/event-registration/event-registration-routing.module.ts